import moment from 'moment';
import React from 'react';
// ##### 24-05-10 Komarov
import uniqueId from 'lodash.uniqueid';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import dateFormats from '../../../../../helpers/dateFormats';
// ##### 24-05-10 Komarov
import { setHotelDatesDivOpened } from '../../../../../Redux/actions';
// ##### 25-05-21 Komarov
import OkButton from './OkButton';
// ##### 25-05-02 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const CalendarHeader = ({ markedDates, calendarHeader }) => {
  // ##### 25-05-10 Komarov
  const searchProps = useValidateQuery();
  const locale = useSelector(state => state.language);
  // ##### Komarov 2025-08-05
  const StartDate = useLocalizedText('StartDate');
  const EndDate = useLocalizedText('EndDate');
  // ##### 24-01-17 Komarov: Включаем в настройках moment текущую локаль
  moment.locale(locale);

  const dispatch = useDispatch();
  // ##### 24-02-20 Komarov
  const onCloseClick = () => {
    markedDates.current.clear();
    dispatch(setHotelDatesDivOpened(false));
  };

  return (
    <div
      data-component="CalendarHeader"
      key={uniqueId()}
      ref={calendarHeader}
      className="calendar-row align-items-center"
      style={{
        border: '1px solid #ccc',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      {/* ##### 24-05-20 Komarov */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flex: 1,
        }}
      >
        <div id="headerStartDate" data-isdateselected={false}>
          { /* ##### Komarov 2025-07-21 */}
          {(searchProps?.start &&
            moment(searchProps.start, dateFormats[locale]).isValid() &&
            moment(searchProps.start, dateFormats[locale])) ||
            (searchProps?.start &&
              moment(searchProps.start, dateFormats.en).format(
                dateFormats[locale]
              )) ||
            StartDate}
        </div>
        <div>&nbsp;&mdash;&nbsp;</div>
        <div id="headerEndDate" data-isdateselected={false}>
          {(searchProps?.end &&
            moment(searchProps.end, dateFormats[locale]).isValid() &&
            moment(searchProps.end, dateFormats[locale])) ||
            (searchProps?.end &&
              moment(searchProps.end, dateFormats.en).format(
                dateFormats[locale]
              )) ||
            EndDate}
        </div>
      </div>
      {/* ##### 24-05-16 Komarov: Кнопка OK для закрытия div`а с содержимым HotelDates */}
      <div
        style={{
          // ##### 24-05-20 Komarov
          /* right: "0.4em",
          position: "absolute", */
          display: 'flex',
          justifyContent: 'space-around',
          width: '22%',
        }}
      >
        <OkButton markedDates={markedDates} />
        <div
          style={{
            fontSize: 'xx-large',
            // right: "0.4em",
            // position: "absolute",
            color: '#005aeb',
          }}
          onClick={onCloseClick}
          onKeyDown={e => {
            // Trigger click action on Enter key press
            if (e.key === 'Enter') {
              onCloseClick();
            }
          }}
        >
          {/* ##### 24-08-16 Komarov */}
          &times;
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
